import { render, staticRenderFns } from "./ConsentForm.vue?vue&type=template&id=502785de&scoped=true&"
import script from "./ConsentForm.vue?vue&type=script&lang=js&"
export * from "./ConsentForm.vue?vue&type=script&lang=js&"
import style0 from "./ConsentForm.vue?vue&type=style&index=0&id=502785de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502785de",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/consent_form.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FConsentForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports